import TopNDropdownItem from "../../../table-actions-panel/models/selection-dropdown-item/TopNDropdownItem/TopNDropdownItem";

export default class TopNCompaniesSelectionItem extends TopNDropdownItem {
    getSelectedTranslation() {
        return {
            key: "si.table-actions-panel.options.companies.top-n.selected",
            replacements: {
                n: this.formatValue(),
            },
        };
    }
}
